import React, { useEffect, useState } from 'react'
import _ from 'lodash'

import Select from 'components/common/Select'
import Input from 'components/common/Input'
import DataTypeIcon from 'components/common/DataTypeIcon'
import DatePicker from 'components/common/DatePicker'
import IconHeaderFlag from 'components/common/IconHeaderFlag'

import Box from 'components_new/atoms/Box'
import Divider from 'components_new/atoms/Divider'
import Icon from 'components_new/atoms/Icon'
import Paper from 'components_new/atoms/Paper'
import Tooltip from 'components_new/atoms/Tooltip'

import ToggleButton from 'components_new/molecules/ToggleButton'

import Filters from './Filters'

import { getDateOptions, DATE_UNITS, TODAY } from './conf'

import { OPERATION_TYPES } from '../conf'

const TimeDifferenceOperation = ({
  chosenAttributes,
  filterData,
  setFilterData,
  type
}) => {
  const [columnState, setNewColumnState] = useState({ from: true, to: true })
  const [stateChosenAttributes, setStateChosenAttributes] = useState(
    _.cloneDeep(chosenAttributes)
  )
  const newAttributeName = filterData.newAttribute || ''

  useEffect(() => {
    if (newAttributeName in stateChosenAttributes) {
      const copyState = _.cloneDeep(stateChosenAttributes)

      delete copyState[newAttributeName]
      setStateChosenAttributes(copyState)
    }

    // check for relative or absolute date
    // valueType is needed because form for value will not be
    // rendered if valueType = __TODAY__
    const renderDateBox =
      filterData.value || filterData.valueType ? false : true

    setNewColumnState({
      from: !!filterData.leftAttribute || renderDateBox,
      to: !!filterData.rightAttribute || renderDateBox
    })
  }, [stateChosenAttributes])

  const options = getDateOptions(stateChosenAttributes)

  return (
    <>
      <IconHeaderFlag
        icon={OPERATION_TYPES[type].icon}
        header={OPERATION_TYPES[type].label}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
        <Input
          prefix={<DataTypeIcon type={'BIGINT'} />}
          suffix={
            // eslint-disable-next-line max-len
            <Tooltip title="Resultatet av din tidsperiod kommer att lagras i en ny kolumn. Döp denna kolumn till ett lämpligt namn.">
              <Icon name="HelpOutline" fontSize="small" />
            </Tooltip>
          }
          label={'Kolumn'}
          value={filterData.newAttribute}
          onChange={(value) => {
            setFilterData({ ...filterData, newAttribute: value })
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
        <DateSection
          label={'Från'}
          column={columnState.from}
          itemKey={'from'}
          setNewColumnState={setNewColumnState}
          options={options}
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <DateSection
          label={'Till'}
          itemKey={'to'}
          column={columnState.to}
          setNewColumnState={setNewColumnState}
          options={options}
          filterData={filterData}
          setFilterData={setFilterData}
        />

        <Select
          label={'Tidsenhet'}
          options={DATE_UNITS}
          sorted={false}
          value={filterData.unit}
          onChange={(value) => setFilterData({ ...filterData, unit: value })}
        />
        <small className="secondary">
          <b>Tänk på!</b> Alla beräkningar med tomma värden (NULL) kommer
          resultera i ett tomt värde (NULL).
        </small>
      </Box>
      <Divider sx={{ my: 2 }} />
      <Filters
        chosenAttributes={stateChosenAttributes}
        filterData={filterData}
        setFilterData={setFilterData}
      />
    </>
  )
}

const DateSection = ({
  label,
  column,
  setNewColumnState,
  itemKey,
  options,
  filterData,
  setFilterData
}) => {
  const otherKey = itemKey === 'from' ? 'to' : 'from'
  const formKey = itemKey === 'from' ? 'leftAttribute' : 'rightAttribute'

  return (
    <Paper
      sx={{ p: 1, display: 'flex', flexDirection: 'column', gap: 1 }}
      variant="outlined"
    >
      {column ? (
        <Select
          label={label}
          placeholder={label}
          options={options}
          labelBackground
          value={filterData[formKey]}
          onChange={(value) => {
            setFilterData({ ...filterData, [formKey]: value })
          }}
        />
      ) : (
        <>
          <Select
            label={label}
            placeholder={label}
            options={[
              { value: TODAY, label: 'Idag' },
              { value: 'INPUT_VALUE', label: 'Specifikt datum' }
            ]}
            labelBackground
            value={filterData.valueType}
            onChange={(value) => {
              setFilterData({ ...filterData, valueType: value, value: null })
            }}
          />
          {filterData.valueType === 'INPUT_VALUE' ? (
            <DatePicker
              label={'Datum'}
              labelBackground
              value={filterData.value}
              onChange={(value) => setFilterData({ ...filterData, value })}
            />
          ) : null}
        </>
      )}

      <ToggleButton
        items={[
          { title: 'Kolumn', value: true },
          { title: 'Datum', value: false }
        ]}
        onChange={(event, value) => {
          const nextFilterData = { ...filterData }

          if (!value) {
            // specific date, unset previous column value
            if (itemKey === 'from') {
              nextFilterData.leftAttribute = null
            } else {
              nextFilterData.rightAttribute = null
            }
          }
          // change state, unset value
          nextFilterData.value = null
          nextFilterData.valueType = null
          setFilterData(nextFilterData)
          setNewColumnState((currentState) => ({
            [itemKey]: value,
            [otherKey]:
              !currentState[otherKey] && !value ? true : currentState[otherKey]
          }))
        }}
        size="small"
        value={column}
      />
    </Paper>
  )
}

export default TimeDifferenceOperation
